import * as z from "zod";

export const NewsSchema = z.object({
  Id: z.number(),
  Title: z.string(),
  ContentE: z.string(),
  ContentA: z.string(),
  CreationDate: z.string().or(z.date()),
  UpdateDate: z.string().or(z.date()),
  StartDate: z.string().or(z.date()),
  EndDate: z.string().or(z.date()),
  Urgency: z.boolean(),
  IsActive: z.boolean(),
  UpdatedBy: z.string(),
  CreatedBy: z.string(),
});

export const NewsContentPageItemCMSSchema = z.object({
  Id: z.number(),
  PageId: z.number(),
  VersionNumber: z.number().optional(),
  ContentTextE: z.string(),
  ContentTextA: z.string(),
  IsPublish: z.boolean(),
  CreationDate: z.string().or(z.date()),
  UpdateDate: z.string().or(z.date()),
  CreatedBy: z.string().optional(),
  UpdatedBy: z.string(),
});

export const NewsContentPageItemSchema = z.object({
  Id: z.number(),
  TitleE: z.string(),
  TitleA: z.string(),
  PageName: z.string(),
  IsActive: z.boolean(),
  CreationDate: z.string().or(z.date()),
  UpdateDate: z.string().or(z.date()),
  CreatedBy: z.string().or(z.null()).optional(),
  UpdatedBy: z.string(),
  CMS_Content: z.array(NewsContentPageItemCMSSchema),
});

export const NewsContentPageResponseSchema = z.object({
  ContentPageDto: z.array(NewsContentPageItemSchema),
});

export type News = z.infer<typeof NewsSchema>;

export type NewsResponse = News[];

export type NewsContentPageItemCMS = z.infer<
  typeof NewsContentPageItemCMSSchema
>;

export type NewsContentPageItem = z.infer<typeof NewsContentPageItemSchema>;

export type NewsContentPageResponse = NewsContentPageItem[];
